var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemperatureGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 35,
    viewBox: "0 0 18 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#68AC58",
    d: "M9.31 19.782c1.807.67 3.102 2.476 3.102 4.599s-1.295 3.93-3.103 4.599v.277H6.206v-.277c-1.808-.67-3.103-2.476-3.103-4.599s1.295-3.93 3.103-4.599v-3.528H9.31v3.528z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#68AC58",
    strokeWidth: 1.067,
    d: "M3.103 17.879V4.655C3.103 2.084 5.187 0 7.758 0c2.57 0 4.654 2.084 4.654 4.655v13.224c1.884 1.482 3.103 3.843 3.103 6.502 0 4.488-3.473 8.127-7.757 8.127C3.473 32.508 0 28.869 0 24.38c0-2.659 1.219-5.02 3.103-6.502z",
    transform: "translate(1 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureGreen);
export default __webpack_public_path__ + "static/media/temperature_green.8a25bea05040e75271d31b1c54da60a6.svg";
export { ForwardRef as ReactComponent };